/**
* In this file contains the delete confirmation popup
**/
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function DeleteModal(props) {
	
	/**
	* To close the delete modal
	**/
	const closeModal = () => {
		props.handleClose();
	}
	
	/**
	**  To close the view delete modal
	*@value pass the boolean value
	**/
	const deleteConfirmation = (value)=> {
	  const data:any = {
		value: value,
		id: props.data.id
	};
		props.handleDelete(data);
		closeModal();
	}
	const { t } = useTranslation();
	return (
	<Modal 
		show= {props.data.delete}
		onHide={props.handleClose}  
		backdrop="static"
		keyboard={false}
		size="md"
		aria-labelledby="contained-modal-title-vcenter"
		centered
	>
	{/*Body*/}
	<Modal.Body>
		<div className="modal-body text-center">
			<h1 className={props?.data?.modal === 'success' ? 'text-success' : 'text-danger'}>
				<i className={props?.data?.modal === 'success' ? 'ri-checkbox-circle-line' : 'ri-close-circle-line'}></i>
			</h1>
			<h4>{ props?.data?.modal !== 'success' ? t('table.sure') : t('table.success') }</h4>
			<p>{ props?.data?.modal !== 'success' ? t('table.deleteConfirm') : t('table.deleteSuccess') } </p>
		</div>
	</Modal.Body>
	{/*Footer*/}
	<Modal.Footer>
		<div className=" d-flex justify-content-center">
			<button type="button" className="btn btn-sm btn-secondary mx-2" onClick={closeModal}>{t('modal.close')}</button>
			{props.data?.modal !== 'success' && <button type="button" className="btn btn-sm btn-danger" onClick={()=>deleteConfirmation(true)} >{t('modal.delete')}</button>}
			{props.data?.modal === 'success' && <button type="button" onClick={closeModal} className="btn btn-sm btn-success" >Ok</button>}
		 </div>
	</Modal.Footer>
	{/*End Footer*/}
	</Modal>
	);
}


export default DeleteModal;
